<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title" *ngIf="currentPage !== 'dashboard' && currentPage !== 'profile' && currentPage !== 'documents'">Contact Us</h5>
            <h5 class="modal-title" *ngIf="currentPage == 'dashboard' || currentPage == 'profile' || currentPage == 'documents'">Contact My Advisor</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="shared.contact-us-modal.close-btn"
                (click)="activeModal.dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="font-18 pb-2" *ngIf="currentPage !== 'dashboard' && currentPage !== 'profile' && currentPage !== 'documents'">Please enter your message below. We will reply to your email shortly.</div>
    <div class="font-18 pb-2" *ngIf="currentPage == 'dashboard' || currentPage == 'profile' || currentPage == 'documents'">Please enter your message below. Whoever you select to receive the message will reply shortly.</div>
    <form [formGroup]="contactUsForm" novalidate>
        <div class="pb-4"  *ngIf="currentPage == 'dashboard' || currentPage == 'profile' || currentPage == 'documents'">
            <select  class="form-control" [(ngModel)]="contact_advisor" formControlName="contactAdvisor"
                data-testid="shared.contact-us-modal.recipient-select"
                aria-label="Select Recipient">
                <option value='' selected>Select Recipient</option>
                <option *ngFor="let option of advisoryTeam" value="{{option.id}}">{{option.name}} -
                    {{option.user_type}} </option>
            </select>
        </div>
        <div class="pb-4">
            <input type="text" #subject class="form-control" placeholder="Subject" [(ngModel)]="contact_subject"
                formControlName="contactSubject" autofocus="true"
                data-testid="shared.contact-us-modal.subject-input"
                aria-label="Subject">
            <div *ngIf="contactUsFormSubmitted" class="text-danger" role="alert">
                <div *ngIf="formControl.contactSubject.errors?.required">Subject is mandatory.</div>
            </div>
        </div>
        <div class="pb-4">
            <textarea #message class="form-control" placeholder="Type your Message here" rows="8" columns="12"
                [(ngModel)]="contact_message" formControlName="contactMessage"
                data-testid="shared.contact-us-modal.message-textarea"
                aria-label="Message"></textarea>
            <div *ngIf="contactUsFormSubmitted" class="text-danger" role="alert">
                <div *ngIf="formControl.contactMessage.errors?.required">Message is mandatory.</div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="closeModal()" [disabled]="disableBtn"
        data-testid="shared.contact-us-modal.cancel-btn">
        CANCEL
    </button>
    <button type="button" class="btn btn-primary btn-sm rounded-pill" (click)="sendMessage()" [formvalid]="contactUsForm.valid" appButtonDisable
        data-testid="shared.contact-us-modal.send-btn">
        Send Message
    </button>
</div>
